import { createContext, useContext, useState, useCallback } from "react";
import { translations } from "@/i18n/translations";

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    const param = new URLSearchParams(window.location.search).get("lang");
    if (param === "es" || param === "en") {
      localStorage.setItem("bella_lang", param);
      return param;
    }
    const saved = localStorage.getItem("bella_lang");
    if (saved) return saved;
    const dev = (navigator.language || navigator.userLanguage || "es").toLowerCase();
    return dev.startsWith("en") ? "en" : "es"; // Spanish primary, English only if device is English
  });
  const setLang = useCallback((l) => {
    localStorage.setItem("bella_lang", l);
    setLangState(l);
  }, []);
  const t = translations[lang] || translations.es;
  return <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>;
}

export const useI18n = () => useContext(I18nContext);

export const fmtDate = (iso, lang) => (iso ? new Date(iso).toLocaleDateString(lang === "en" ? "en-US" : "es-CR", { day: "numeric", month: "short", year: "numeric" }) : "");

export function LanguageToggle({ className = "" }) {
  const { lang, setLang } = useI18n();
  return (
    <div data-testid="lang-toggle" className={`inline-flex items-center rounded-full border border-current/15 overflow-hidden text-xs font-bold ${className}`}>
      {["es", "en"].map((l) => (
        <button
          key={l}
          data-testid={`lang-${l}`}
          onClick={() => setLang(l)}
          className={`px-2.5 py-1 transition-colors ${lang === l ? "bg-[#2C3E35] text-[#FDFBF9]" : "opacity-60 hover:opacity-100"}`}
        >
          {l.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
